import { createRouter, createWebHistory } from 'vue-router';
import Layout from '@/components/layouts/LayoutComponent.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: Layout,
    children: [
      { path: '', component: () => import('@/views/HomePage.vue') }
    ],
  },
  {
    path: '/contact-us',
    name: 'contact-us',
    component: Layout,
    children: [
      { path: '', component: () => import('@/views/ContactPage.vue') }
    ],
  },
  {
    path: '/blogs',
    name: 'blogs',
    component: Layout,
    children: [
      { path: '', component: () => import('@/views/BlogPage.vue') },
      { path: 'detail/:id', component: () => import('@/views/BlogDetailPage.vue') }
    ],
  },
  {
    path: '/careers',
    name: 'careers',
    component: Layout,
    children: [
      { path: '', component: () => import('@/views/CareerPage.vue') }
    ],
  },
  {
    path: '/about-us',
    name: 'about-us',
    component: Layout,
    children: [
      { path: '', component: () => import('@/views/AboutUsPage.vue') }
    ],
  },
  {
    path: '/service',
    name: 'service',
    component: Layout,
    children: [
      { path: '', component: () => import('@/views/ServicePage.vue') },
      { path: 'detail/:slug', component: () => import('@/views/ServiceDetailPage.vue') }
    ],
  },
  {
    path: '/servicesdetail',
    name: 'servicesdetail',
    component: Layout,
    children: [
      { path: '', component: () => import('@/views/ServiceDetailPage.vue') }
    ],
  },
  {
    path: '/achievements',
    name: 'Achievements',
    component: Layout,
    children: [
      { path: '', component: () => import('@/views/AchievementsPage.vue') }
    ],
  },
  {
    path: '/disclaimers',
    name: 'Disclaimers',
    component: Layout,
    children: [
      { path: '', component: () => import('@/views/DisclaimerPage.vue') }
    ],
  },
  {
    path: '/privacy-policy',
    name: 'Privacy-policy',
    component: Layout,
    children: [
      { path: '', component: () => import('@/views/PrivacyPolicyPage.vue') }
    ],
  },
  {
    path: '/child-safety-policy',
    name: 'Child-safety-policy',
    component: Layout,
    children: [
      { path: '', component: () => import('@/views/ChildSafetyPolicy.vue') }
    ],
  },
  {
    path: '/portfolio',
    name: 'Portfolio',
    component: Layout,
    children: [
      { path: '', component: () => import('@/views/PortfolioPage.vue') }
    ],
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0, behavior: 'smooth' }; // Scroll to top on navigation
  }
});

export default router;
